const FullScreenLoader: React.FC = () => {
  return <>TODO: create loader</>;
};

export default FullScreenLoader;
